import EmptyState, {
  EmptyStateProps,
} from "shared/components/empty/EmptyState";
import { LoadingState } from "shared/components/empty/LoadingState";

export interface OverlayProps {
  emptyStateProps?: EmptyStateProps;
  isLoading?: boolean;
  isEmpty?: boolean;
}

export const LoadingOverlayComponent: React.FC<OverlayProps> = () => (
  <LoadingState delay={0} />
);

export const NoRowsOverlayComponent: React.FC<OverlayProps> = ({
  emptyStateProps,
}) => <EmptyState {...emptyStateProps} />;
